@if (context$ | async; as context) {
  <div
    *transloco="let t; scope: 'featureHome'"
    class="bd-home-container"
    [ngClass]="{
      'bd-home-default': context === 'default',
    }"
  >
    @if (context === 'default') {
      <h1
        data-id="home-heading"
        class="text-center bd-headline-regular bd-home-heading"
      >
        {{ t('featureHome.heading') }}
      </h1>
      <h5
        data-id="home-subheading"
        class="text-center bd-sub-headline-regular bd-home-subheading"
      >
        {{ t('featureHome.subheading') }}
      </h5>
    }
    <bd-split-search-container
      [context]="context"
      class="contents"
    ></bd-split-search-container>
    @let recentWorkspaces = recentWorkspaces$ | async;

    @if (context === 'default') {
      @if (recentWorkspacesLoading) {
        <p
          [attr.data-id]="labelDataId()"
          class="bd-label-regular bd-recently-used-label"
        >
          {{ t(labelKey()) }}
        </p>
        <bd-item-grid-loading
          data-id="recent-workspaces-items-grid-loading"
          class="bd-home-recent-grid"
          variant="grid"
          [loadingItemsCount]="3"
        ></bd-item-grid-loading>
      } @else if (recentWorkspaces && recentWorkspaces.length > 0) {
        <p
          [attr.data-id]="labelDataId()"
          class="bd-label-regular bd-recently-used-label"
        >
          {{ t(labelKey()) }}
        </p>
        <bd-item-grid
          data-id="recent-workspaces-items-grid"
          class="bd-home-recent-grid"
          [items]="recentWorkspaces"
        >
        </bd-item-grid>
      }
    }
  </div>
}
